import { BaseService } from "./base.service";

class Service extends BaseService {

}

export const HerbFunctionService = new Service('/herb-function');